import HistoryOfSelection from 'components/Desktop/HistoryOfSelection'
import { SppWorkList1C } from 'components/SPP/SppWorkList1C/SppWorkList1C'
import { SppWorkListComments } from 'components/SPP/SppWorkListComments/SppWorkListComments'
import { SppWorkListCreditRequests } from 'components/SPP/SppWorkListCreditRequests/SppWorkListCreditRequests'
import { SppWorkListEstimate } from 'components/SPP/SppWorkListEstimate/SppWorkListEstimate'

export const wlViewTabs = [
  {
    label: 'Комментарии',
    component: SppWorkListComments
  },
  {
    label: 'Кредитные заявки',
    component: SppWorkListCreditRequests
  },
  {
    label: 'РЛ оценки',
    component: SppWorkListEstimate
  },
  {
    label: '1С и оплата',
    component: SppWorkList1C
  },

  {
    label: 'История подбора',
    component: HistoryOfSelection
  }
]
